import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { BankAccountSettingsFormValues } from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import { bankConfig } from '@/core/domain/financial/Boletos/Boletos.dictionary';
import { Col, Form, FormInstance, Row, Select } from 'antd';

interface Props {
  form: FormInstance<BankAccountSettingsFormValues>;
  bankAccount?: BankAccount;
}

export default function ConfigBankSlipFineForm({ form, bankAccount }: Props) {
  const bankMapFields = bankAccount ? bankConfig[bankAccount?.bank.code] : null;

  return (
    <Form form={form} name="bankAccountConfigBullet">
      <Row gutter={[12, 12]}>
        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Código multa"
            name={['fine', 'titleFineCode']}
          >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={[
                {
                  value: '0',
                  label: 'Não registra a multa.',
                },
                {
                  value: '1',
                  label: 'Valor em Reais (Fixo)',
                },
                {
                  value: '2',
                  label: 'Valor em percentual com duas casas decimais',
                },
              ]}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Dias multa após vencimento"
            name={['fine', 'titleFineDays']}
          >
            <InputDecimal fractions={0} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Valor multa taxa"
            name={['fine', 'titleFineRateValue']}
          >
            <InputDecimal
              fractions={bankMapFields?.fields.titleFineRateValue?.fractions}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
